import clsx from "clsx"

import type { FCWithChildren } from "~/types/react"

const TailwindProseWrapper: FCWithChildren<{ className?: string }> = ({
  className,
  children,
}) => {
  return (
    <div
      className={clsx(
        "prose my-8 mx-auto dark:prose-dark md:my-16 lg:prose-lg xl:prose-xl",
        className,
      )}
    >
      {children}
    </div>
  )
}

export default TailwindProseWrapper
